module.exports = __webpack_public_path__ + "static/media/icon-mine.22e8ddb0.svg";